/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Box, Grid, Divider, FormControl, Select, MenuItem, Typography, Card, Pagination } from '@mui/material';
import ProductCard from '../../components/ProductCard';
import FilterSidebar from '../../components/FilterSidebar';
import productsData from '../../jsons/products.json';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishlist, removeFromWishlist } from '../../redux/wishlistSlice';
import { capitalize } from '../Utils'; // Import a utility function to capitalize the first letter

const BestSelling = ({ category }) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({
    category: category ? [capitalize(category.replace(/-/g, ' '))] : [],
    priceRange: [0, 100],
    language: [],
    bindingType: []
  });
  const [sortBy, setSortBy] = useState('rating-desc');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 8; // Adjust as needed
  const dispatch = useDispatch();
  const wishlist = useSelector(state => state.wishlist.wishlist);

  useEffect(() => {
    setProducts(productsData);
    setFilteredProducts(productsData);
  }, []);

  useEffect(() => {
    applyFiltersAndSorting();
  }, [products, filters, sortBy]);

  useEffect(() => {
    if (category) {
      setFilters(prevFilters => ({
        ...prevFilters,
        category: [capitalize(category.replace(/-/g, ' '))]
      }));
    }
  }, [category]);

  const applyFiltersAndSorting = () => {
    let filtered = products;

    if (filters.category.length > 0) {
      filtered = filtered.filter(product => filters.category.includes(product.category));
    }

    filtered = filtered.filter(product => parseFloat(product.price) >= filters.priceRange[0] && parseFloat(product.price) <= filters.priceRange[1]);

    if (filters.language.length > 0) {
      filtered = filtered.filter(product => filters.language.includes(product.language));
    }

    if (filters.bindingType.length > 0) {
      filtered = filtered.filter(product => filters.bindingType.includes(product.bindingType));
    }

    switch (sortBy) {
      case 'rating-desc':
        filtered.sort((a, b) => b.rating - a.rating);
        break;
      case 'rating-asc':
        filtered.sort((a, b) => a.rating - b.rating);
        break;
      case 'price-desc':
        filtered.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
        break;
      case 'price-asc':
        filtered.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
        break;
      default:
        break;
    }

    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to the first page whenever filters or sorting changes
  };

  const handleFilterChange = (type, value, checked) => {
    switch (type) {
      case 'category':
      case 'language':
      case 'bindingType':
        if (checked) {
          setFilters(prevFilters => ({
            ...prevFilters,
            [type]: [...prevFilters[type], value]
          }));
        } else {
          setFilters(prevFilters => ({
            ...prevFilters,
            [type]: prevFilters[type].filter(item => item !== value)
          }));
        }
        break;
      case 'priceRange':
        setFilters(prevFilters => ({
          ...prevFilters,
          priceRange: value
        }));
        break;
      default:
        break;
    }
  };

  const handleSortByChange = (event) => {
    setSortBy(event.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const addToWishlistHandler = (productId) => {
    const product = products.find(prod => prod.id === productId);
    if (product) {
      dispatch(addToWishlist(product)); // Pass entire product object to addToWishlist action
    }
  };

  const removeFromWishlistHandler = (productId) => {
    dispatch(removeFromWishlist(productId));
  };

  const isInWishlist = (productId) => {
    return wishlist.some(item => item.id === productId);
  };

  const startIndex = (currentPage - 1) * productsPerPage;
  const endIndex = startIndex + productsPerPage;
  const currentProducts = filteredProducts.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  return (
    <Box sx={{ display: 'flex', backgroundColor: '#eef2f6', pt: 2 }}>
      {/* Sidebar for filters */}
      <FilterSidebar filters={filters} onFilterChange={handleFilterChange} />

      {/* Product grid */}
      <Box sx={{ width: '75%', pl: 2 }}>
        <Card sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h5" component="h2">
            {category ? capitalize(category.replace(/-/g, ' ')) : 'Best Selling'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
            <Typography variant="body1" sx={{ mr: 2 }}>
              Sort by:
            </Typography>
            <FormControl variant="outlined" sx={{ minWidth: 150 }}>
              <Select
                value={sortBy}
                onChange={handleSortByChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Sort by' }}
              >
                <MenuItem value="rating-desc">Rating: High to Low</MenuItem>
                <MenuItem value="rating-asc">Rating: Low to High</MenuItem>
                <MenuItem value="price-desc">Price: High to Low</MenuItem>
                <MenuItem value="price-asc">Price: Low to High</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Card>

        {/* Divider line */}
        <Divider sx={{ mb: 2 }} />

        {/* Product list */}
        <Grid container spacing={2}>
          {currentProducts.map((product) => (
            <Grid item key={product.id} xs={12} sm={6} md={4} lg={3}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>

        {/* Pagination */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            sx={{
              '& .MuiPaginationItem-root': {
                color: '#000', // Customize the color of pagination items
                '&.Mui-selected': {
                  backgroundColor: '#1976d2',
                  color: '#fff'
                }
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BestSelling;